var exports = {
  "NQ": "xfd349460--7e3e6a--review",
  "Xk": "xfd349460--7e3e6a--review--link",
  "gX": "xfd349460--7e3e6a--review--link--rating",
};

module.exports = exports;
